export default __webpack_public_path__ + "static/media/set1.79cf5d55.jpeg";